import { GetApplicationSetting } from "../../../assets/configuration";

export const headerLinks = [
  
    { label: "Features", href: "/#features" },
    { label: "News", href: "/#news" },
    { label: "About", href: "/#about" },

    { label: "Contact", href: "/#contact" },
    { label: "Login", href: `${GetApplicationSetting.serviceSettings.applicationUrl}/signin` },
];
